export const slideSettings = (dataLenght: number) => {
  const slideSizeBiggerFour = dataLenght >= 4;

  const settings = {
    dots: slideSizeBiggerFour,
    arrows: false,
    infinite: false,
    slidesToShow: 1.1,
  };

  return settings;
};
